<template>
  <button class="statement-row" @click="onClick">
    <Row :class="computedClass" has-interaction>
      <template #top-left>
        {{ statement.month.formatted }}
      </template>
      <template #icon-right>
        <LoaderIndicator v-if="loading" size="24" />
        <BaseIcon v-else icon="EA0230" />
      </template>
    </Row>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { PortfolioMonthlyStatement } from '@/modules/wealth/services/portfolio';

import { BaseIcon, Row, LoaderIndicator } from '@warrenbrasil/nebraska-web';

interface Props {
  statement: PortfolioMonthlyStatement;
  disabled: boolean;
  loading: boolean;
}
const props = defineProps<Props>();

interface Emits {
  (event: 'on-click'): void;
}
const emit = defineEmits<Emits>();

const computedClass = computed(() => {
  return {
    'statement-row--disabled': props.disabled,
    'statement-row--loading': props.loading
  };
});

const onClick = () => {
  if (props.disabled || props.loading) return;
  emit('on-click');
};
</script>

<style lang="less" scoped>
.statement-row {
  display: block;
  width: 100%;
  padding: 0;

  &--disabled,
  &--loading {
    color: @element-disabled;
    cursor: not-allowed !important;
  }
}
</style>
